import React, {
    type Dispatch,
    type SetStateAction, useCallback,
} from 'react';


import {DateRangeInput} from 'src/components/input';
import {WidthItem} from 'src/components/width-item';
import {ValidatedControl} from 'src/contexts/validation-context';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import {
    LICENSE_END_DATE_CONTROL,
    LICENSE_START_DATE_CONTROL,
} from '../constants';

import type {CreateConferenceData} from '../useCreateConference';

const SECTION_NAME = 'License Information';

type Props = {
    data: CreateConferenceData,
    setData: Dispatch<SetStateAction<CreateConferenceData>>,
    trackParameterChange: (parameter: string) => void,
};

export const LicenseDuration = (props: Props) => {
    const {data, setData, trackParameterChange} = props;

    const changeStartDate = useCallback((date: string) => {
        setData(prev => ({...prev, licenseStartDate: date || undefined}));
        trackParameterChange('Conference license Start Date');
    }, [setData, trackParameterChange]);

    const changeEndDate = useCallback((date: string) => {
        setData(prev => ({...prev, licenseEndDate: date || undefined}));
        trackParameterChange('Conference license End Date');
    }, [setData, trackParameterChange]);

    return (
        <FormSection headline={SECTION_NAME}>
            <Label>License Period</Label>
            <Group direction="v" gap="s">
                <ValidatedControl name={LICENSE_START_DATE_CONTROL}>
                    {(invalid: boolean) => (
                        <WidthItem width={320}>
                            <DateRangeInput
                                id="start-date-picker"
                                width={320}
                                label="Starts"
                                invalid={invalid}
                                clearable={true}
                                startDate={data.licenseStartDate}
                                endDate={data.licenseEndDate}
                                selectRangeType="start"
                                onChange={changeStartDate}
                            />
                        </WidthItem>
                    )}
                </ValidatedControl>
                <ValidatedControl name={LICENSE_END_DATE_CONTROL}>
                    {(invalid: boolean) => (
                        <WidthItem width={320}>
                            <DateRangeInput
                                id="end-date-picker"
                                width={320}
                                label={<>Ends&nbsp;&nbsp;</>}
                                invalid={invalid}
                                clearable={true}
                                preventPastDate={true}
                                startDate={data.licenseStartDate}
                                endDate={data.licenseEndDate}
                                selectRangeType="end"
                                onChange={changeEndDate}
                            />
                        </WidthItem>
                    )}
                </ValidatedControl>
            </Group>
        </FormSection>
    );
};
